var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCategoryIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 0C1.79086 0 0 1.79086 0 4C0 6.20917 1.79086 8 4 8C1.79086 8 0 9.79083 0 12C0 14.2092 1.79086 16 4 16C6.20917 16 8 14.2092 8 12C8 14.2092 9.79083 16 12 16C14.2092 16 16 14.2092 16 12C16 9.79083 14.2092 8 12 8C14.2092 8 16 6.20917 16 4C16 1.79086 14.2092 0 12 0C9.79083 0 8 1.79086 8 4C8 1.79086 6.20917 0 4 0Z",
    fill: "#2D65F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryIcon2);
export default __webpack_public_path__ + "static/media/category_icon2.8ea394d40918cd37c428c004af000596.svg";
export { ForwardRef as ReactComponent };